import Link from 'next/link'
import { Connector } from '@/components/connector'
import { usePathname } from 'next/navigation'
import clsx from 'clsx'
import Search from '@/views/V3Info/components/Search'
import { HamburgerIcon } from '@pancakeswap/uikit'
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet'
import { GlobalSettingsPopover } from '@/components/popovers/global-settings'
import { useAccount } from 'wagmi'
import { LogoIcon } from '@/components/icons/logo'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from '@/components/ui/navigation-menu'
import Image from 'next/image'
import { Input } from '@/components/ui/input'
import { SearchDialog } from '@/search-dialog'
import { SearchIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

const links = [
  {
    name: 'Swap',
    items: [
      {
        name: 'Swap',
        href: '/swap',
      },
      {
        name: 'Liquidity',
        href: '/liquidity',
      },
    ],
  },
  {
    name: 'Earn',
    href: '/earn',
  },
  {
    name: 'Explore',
    href: '/explore/v3',
  },
]

export const Header = () => {
  const { address } = useAccount()
  const pathname = usePathname()

  return (
    <header className={'py-4 fixed top-0 w-full z-50 bg-background/10 px-4 backdrop-blur-2xl'}>
      <div className="container mx-auto flex items-center justify-between relative">
        <div className="flex items-center">
          <Link
            className="flex items-center gap-1 lg:text-2xl text-xl font-semibold italic text-zap font-averia-libre"
            href={'/'}
          >
            <LogoIcon />
            MoonSwap
          </Link>
          <div className={'lg:flex ml-10 gap-8 hidden font-averia-libre'}>
            <NavigationMenu orientation={'vertical'} viewport={false}>
              <NavigationMenuList>
                {links.map((link) => (
                  <div key={link.name}>
                    {link?.items && link.items.length > 0 ? (
                      <NavigationMenuItem>
                        <NavigationMenuTrigger>{link.name}</NavigationMenuTrigger>
                        <NavigationMenuContent>
                          {link?.items?.map((item) => (
                            <Link
                              href={item.href}
                              key={item.name}
                              className={clsx('text-muted-foreground hover:text-primary block w-full', {
                                'text-primary': item.href === pathname,
                              })}
                            >
                              <NavigationMenuLink className={navigationMenuTriggerStyle()}>
                                {item.name}
                              </NavigationMenuLink>
                            </Link>
                          ))}
                        </NavigationMenuContent>
                      </NavigationMenuItem>
                    ) : (
                      <NavigationMenuItem>
                        <Link href={link.href || ''}>
                          <NavigationMenuLink
                            className={cn(navigationMenuTriggerStyle(), {
                              'text-zap': pathname?.includes(link.href || ''),
                            })}
                          >
                            {link.name}
                          </NavigationMenuLink>
                        </Link>
                      </NavigationMenuItem>
                    )}
                  </div>
                ))}
              </NavigationMenuList>
            </NavigationMenu>
          </div>
        </div>

        <div className={'absolute left-1/2 -translate-x-1/2'}>
          <SearchDialog
            trigger={
              <div>
                <div
                  className={
                    'rounded-full w-[300px] border text-foreground/40 text-sm px-4 py-2 items-center gap-3 md:flex hidden'
                  }
                >
                  <SearchIcon className={'size-5'} />
                  Search address or hl name
                </div>
                <SearchIcon className={'size-5 md:hidden block'} />
              </div>
            }
          />
        </div>
        <div className="flex items-center gap-2">
          <Sheet>
            <SheetTrigger>
              <HamburgerIcon />
            </SheetTrigger>
            <SheetContent side={'bottom'} className={'py-6'}>
              <div className="flex flex-col items-center gap-2">
                {links.map((link) => (
                  <Link
                    href={link.href ?? ''}
                    key={link.name}
                    className={clsx('text-muted-foreground hover:text-primary', {
                      'text-primary': link.href === pathname,
                    })}
                  >
                    {link.name}
                  </Link>
                ))}
              </div>
            </SheetContent>
          </Sheet>
          {!address && <GlobalSettingsPopover />}
          <Connector />
        </div>
      </div>
    </header>
  )
}
